module.exports = __webpack_public_path__ + "img/verified_visa.9d97da83.svg";